import firebase from 'firebase/app';
import React, { useEffect } from 'react';

const Logout = () => {
  useEffect(() => {
    firebase.auth().signOut();
  }, []);
  return (
    <div>
      <h3>Thank you!</h3>
    </div>
  );
};

export default Logout;
